export const defaultChannels = [
  {
    __typename: 'UtmChannel',
    name: 'Other',
    icon: 'folder',
    id: 'd0d59dd5-457e-473c-9d61-9ae6d2772b04',
  },
  {
    __typename: 'UtmChannel',
    name: 'Direct',
    icon: 'arrow-right',
    id: '9e344b47-0ec1-4bc9-8e56-5a7a1f368b06',
  },
]
